import Botao from "../../Botao";


export default function CardConfirma({text, onClick, cancela}: {text: string; onClick: () => void; cancela: () => void} ) {
    return(
        <div>
            <h1>{text}</h1>
            <Botao text={'Confirma'} onClick={onClick}/>
            <Botao style="red" text={'Cancelar'} onClick={cancela}/>
        </div>
    )
}